<template>
  <div id="app">
    <div id="leftChat">
      <img class="logo" :src="require('@/assets/logo6.png')" alt="" />
      <ul class="navlist">
        <li @click="changeTab(1)" :class="navIndex == 1 ? 'active' : ''">
          <img
            class="icon"
            :src="
              navIndex == 1
                ? require('@/assets/director/icon (4).png')
                : require('@/assets/director/icon (1).png')
            "
            alt=""
          />
          <div class="name">
            首&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;页
          </div>
          <div class="red-circle"></div>
        </li>
        <li @click="changeTab(2)" :class="navIndex == 2 ? 'active' : ''">
          <img
            class="icon"
            :src="
              navIndex == 2
                ? require('@/assets/director/icon (6).png')
                : require('@/assets/director/icon (3).png')
            "
            alt=""
          />
          <div class="name">观察档案</div>
          <div class="red-circle"></div>
        </li>

        <li @click="changeTab(3)" :class="navIndex == 3 ? 'active' : ''">
          <img
            class="icon"
            :src="
              navIndex == 3
                ? require('@/assets/director/icon (8).png')
                : require('@/assets/director/icon (5).png')
            "
            alt=""
          />
          <div class="name">成&nbsp;&nbsp;长&nbsp;&nbsp;册</div>
          <div class="red-circle"></div>
        </li>

        <li @click="changeTab(4)" :class="navIndex == 4 && !showMenu ? 'active' : ''">
          <img
            class="icon"
            :src="
              navIndex == 4
                ? require('@/assets/director/icon (7).png')
                : require('@/assets/director/icon (2).png')
            "
            alt=""
          />
          <div class="name">统计进度</div>
          <div class="red-circle"></div>
        </li>
        <ul v-show="navIndex == 4" class="z-menu">
              <li @click="$router.push('/director/report')" :class="metaTitke == '班级统计' ? 'active' : ''">班级统计</li>
              
              <li @click="$router.push('/director/report-teacher')" :class="metaTitke == '教师统计' ? 'active' : ''">教师统计</li>
              <li @click="$router.push('/director/report-admin')" :class="metaTitke == '报告管理' ? 'active' : ''">报告管理</li>
              <li @click="$router.push('/director/report-field')" :class="metaTitke == '领域统计' ? 'active' : ''">观察领域统计</li>
              <li @click="$router.push('/director/report-fieldlevel')" :class="metaTitke == '观察档案统计' ? 'active' : ''">观察档案统计</li>
             
          </ul>
      </ul>
      <img class="child" :src="require('@/assets/enchildren.jpg')" alt="" />
    </div>
    <div id="rightChat">
      <div id="headerChat">
        <div class="headLeft">
          <img
            class="welcome"
            :src="require('@/assets/welcome.jpg')"
            alt=""
          />
          <div class="school">
            {{ school ? school.school_title : "未获取" }}
          </div>
          <div @click="handleSwap" class="swap">
            <a-icon type="swap" />
            <span>切换</span>
          </div>
        </div>
        <div class="headRight">
          <div style="margin-right:22px" class="network">
            <a-tooltip
              placement="bottom"
              v-if="netWork == -1"
              :title="网络已断开"
            >
              <img
                style="width:25px"
                v-if="netWork <= 1"
                src="../../assets/online3.gif"
                alt=""
              />
            </a-tooltip>
            <a-tooltip
              placement="bottom"
              v-if="netWork > 0"
              :title="
                netWork > 200
                  ? '网络状态较差' + netWork
                  : netWork > 100
                  ? '网络状态一般' + netWork
                  : '网络极佳' + netWork
              "
            >
              <img
                style="width:25px"
                v-if="netWork > 200"
                src="../../assets/network-bad.jpg"
                alt=""
              />
              <img
                style="width:25px"
                v-else-if="netWork > 100"
                src="../../assets/network-good.png"
                alt=""
              />
              <img
                style="width:25px"
                v-else
                src="../../assets/network-good.png"
                alt=""
              />
            </a-tooltip>
          </div>
          <!-- <div class="upload">
            <img :src="require('../assets/icon-08.png')" alt="" />
          </div> -->
          <div class="msg">
            <img
              @click="toNews"
              :src="require('@/assets/icon-09.png')"
              alt=""
            />
            <div v-show="$store.state.systemMsg" class="red-msg">
              {{ $store.state.systemMsg > 99 ? "99+" : $store.state.systemMsg }}
            </div>
          </div>
          <div @click="handleShowAi" class="ai">
            <img :src="require('@/assets/ai/ml.png')" alt="" />
            AI小助手
          </div>
          <a-dropdown>
            <a
              class="ant-dropdown-link"
              style="display:flex;align-items:center"
              @click="(e) => e.preventDefault()"
            >
              <img
                class="tx"
                :src="
                  userInfo && userInfo.avatar
                    ? userInfo.avatar
                    : require('@/assets/user2.png')
                "
                alt=""
              />
              <div class="name">
                {{ userInfo ? userInfo.name : "未登录" }}
              </div>
            </a>
            <a-menu slot="overlay">
              <!-- <a-menu-item>
                <a @click="toUserCenter">个人中心</a>
              </a-menu-item> -->
              <a-menu-item>
                <a @click="logoutModal = true">退出登录</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
      </div>
      <div id="ctxChat">
        <div class="main scroll" style="left:0;right:0;overflow-y:auto">
          <div class="scroll-wrap">
            <div class="wrapper">
          <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
          </keep-alive>
          <router-view v-if="!$route.meta.keepAlive"></router-view>
        </div>
          </div>
        </div>
        
      </div>
    </div>
    <ai v-model="showAi"></ai>
    <a-modal :visible="logoutModal" centered :closable="false" footer="">
      <div class="modal3 red">
        <img :src="require('@/assets/log2.png')" alt="" />
        <div class="msg">
          <div class="title">退出当前登录？</div>
          <div class="btns">
            <a-button @click="logoutModal = false">取消</a-button>
            <a-button @click="handleLogout" type="danger">
              确认
            </a-button>
          </div>
        </div>
      </div>
    </a-modal>
    <a-modal
      :visible="schoolModal"
      centered
      footer=""
      @cancel="schoolModal = false"
      width="380px"
    >
      <div class="modal2">
        <div class="head" style="margin-bottom:20px">
          <div class="msg">
            <div class="title">切换学校</div>
          </div>
        </div>
        <a-list
          class="demo-loadmore-list"
          item-layout="horizontal"
          bordered
          :data-source="schoolList"
        >
          <a-list-item slot="renderItem" slot-scope="item, index">
            <div
              v-if="item.id == school.id"
              class="active"
              style="color:#67b0dc"
              slot="actions"
            >
              当前登录
            </div>
            <div
              v-if="item.id != school.id"
              @click="handleChange(index)"
              style="color:#eb5c4b"
              slot="actions"
            >
              切换登录
            </div>
            <a-list-item-meta :description="item.school_title">
              <a slot="title">{{ item.name }}</a>
            </a-list-item-meta>
          </a-list-item>
        </a-list>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Cookies from "js-cookie";
import { directorApi } from "../../api/api-director";
import { EventBus } from "../../utils/eventBus";
import ai from "../ai/index.vue";
export default {
  name: "App",
  data() {
    return {
      navIndex: 0,
      logoutModal: false,
      showFootbtn: false,
      schoolModal: false,
      schoolList: [],
      showAi:false,
      metaTitke:'',
      showMenu:false
    };
  },
  components: {
    ai,
  },
  computed: {
    ...mapState(["headers", "userInfo", "netWork", "school"]),
    networkStyle() {
      return {
        right: 400 + "px",
        bottom: 30 + "px",
      };
    },
  },
  watch: {
    netWork(val) {
      if (val == -1) {
        this.$message.info("网络已断开");
      } else if (val > 200) {
        this.$message.info("当前网络状态较差");
      } else if (val > 100) {
      } else {
      }
    },
    $route(to) {
      console.log(to);
      if (this.navIndex !== null) {
        this.navIndex = to.meta.tabIndex;
        this.metaTitke = to.meta.title

        if (this.navIndex == 4) {
          this.showMenu = true;
        }
      }
      setTimeout(() => {
        if (!this.userInfo && to.path != "/login" && !Cookies.get('token')) {
          this.$message.error("未登录或登录状态过期");
          this.$router.push({ path: "/login" });
        }
      }, 800);
    },
    userInfo(val) {
      if (val) {
        this.getNews(0);
      }
    },
  },
  created() {
    const host = window.location.href;
    if (host.indexOf("test") >= 0) {
      this.showFootbtn = true;
    }
    this.navIndex = this.$route.meta.tabIndex;
    this.metaTitke = this.$route.meta.title
    if (this.navIndex == 4) {
      this.showMenu = true;
    }
    var m = false;
    var n = m ? 0 : 1;
    console.log(n);
    if (this.userInfo) {
      this.getNews(0);
    }
  },
  methods: {
    handleShowAi() {
      this.showAi = !this.showAi;
    },
    handleChange(index) {
      this.$store.dispatch("setSchool", this.schoolList[index]);
      this.schoolModal = false;
      EventBus.$emit("changeSchool", true);
    },
    handleSwap() {
      this.getSchools();
      this.schoolModal = true;
    },
    getSchools() {
      this.$axios({
        method: "GET",
        url: directorApi.domain + directorApi.schoolList,
        headers: { Authorization: this.$store.state.headers },
        params: {
          page: 1,
          PageSize: 100,
        },
      }).then((res) => {
        if (res.data.status == 200) {
          this.schoolList = res.data.data.list;
        }
      });
    },
    toNews() {
      this.$router.push({ path: "/director/news" });
    },
    getNews(type) {
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.newsCount,
        headers: { Authorization: this.$store.state.headers },
        data: {
          type: type,
          student_id: type === 0 ? 0 : this.babyInfo.id,
        },
      })
        .then((res) => {
          switch (type) {
            case 0:
              if (res.data.status == 200 && !res.data.data) {
                this.$store.dispatch("setSystemMsg", 0);
                return false;
              }
              this.$store.dispatch("setSystemMsg", res.data.data);
              break;
            default:
              break;
          }
        })
        .catch((res) => {
          this.$message.error(res.data.msg);
        });
    },
    toUserCenter() {
      this.$router.push({ path: "/center" });
    },
    handleLogout() {
      this.logoutModal = false;
      localStorage.removeItem("uid");
      localStorage.removeItem("school");
      localStorage.removeItem("directorId");
      this.$store.dispatch("logOut");
      this.$router.push({ path: "/director/login" });
    },
    onscroll(e) {
      console.log(e);
    },
    changeTab(index) {
      if (this.navIndex == index) return false;
      this.navIndex = index;
      this.showMenu = false
      switch (index) {
        case 1:
          this.$router.push({ path: "/director/index" });
          break;
        case 2:
          this.$router.push({ path: "/director/observe/indexClass" });
          break;
        case 3:
          this.$router.push({ path: "/director/growupStep" });
          break;
        case 4:
          this.$router.push({ path: "/director/report" });
          this.showMenu = true;
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="scss" >
ol li, ul li {
    font-size: 12px;
}


.ai {
  position: relative;
  padding-right: 26px;
  cursor: pointer;
  box-sizing: border-box;
  margin-right: 30px;
  font-size: 14px;
  height: 40px;
  color: #666;
  &::after {
    content: "";
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 1px;
    height: 20px;
    background: #ddd;
  }
  img {
    width: 40px;
    height: 40px;
    border-radius: 40px;
    margin-right: 2px;
    overflow: hidden;
  }
}
.content ul li {
  margin-top: 0 !important;
}
.modal2 {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  .head {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    .logo {
      width: 50px;
      height: 50px;
      margin-right: 10px;
    }
    .msg {
      flex: 1 1 0%;
      .title {
        color: #67b0dc;
        margin-bottom: 5px;
        font-size: 20px;
      }
    }
  }
  .form {
    width: 100%;
    margin-top: 20px;
    .item {
      width: 100%;
      border: 1px solid #67b0dc;
      border-radius: 8px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;
      height: 66px;
      .label {
        color: #67b0dc;
        font-size: 14px;
        margin-bottom: 5px;
      }
      .left {
        margin-left: 12px;
        .inputbox {
          display: flex;
          flex-direction: row;
          align-items: center;
          input {
            border: none;
            outline: none;
            &::-webkit-input-placeholder {
              color: #898989;
            }
          }
          .getcode {
            color: #fff;
            background: #67b0dc;
            border-radius: 10px;
            font-size: 12px;
            padding: 2px 10px;
            cursor: pointer;
          }
        }
      }
      .btn {
        width: 60px;
        text-align: center;
        line-height: 66px;
        color: #fff;
        background: #67b0dc;
        border-radius: 0 8px 8px 0;
        cursor: pointer;
      }
    }
  }
}


#app {
  color: #000;
}
body {
  overflow: hidden;
  width: 100%;
  height: 100%;
  background: #f1f8fd;
}
#app {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  #leftChat {
    width: 220px;
    height: 100%;
    background: #fff;
    position: relative;
    overflow-y: scroll;
    .logo {
      width: 101px;
      margin-left: 50px;
      margin-top: 50px;
      margin-bottom: 40px;
    }
    .navlist {
      width: 100%;
      box-sizing: border-box;
      list-style: none;
      margin: 0;
      padding: 0 0 0 35px;
      font-size: 16px;
      .z-menu {
        padding-left: 30px;
        margin-top: 5px;
        li {
          line-height: 36px;
          padding-left: 15px;
        }
      }
      li {
        line-height: 45px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        border-radius: 100px 0 0 100px;
        color: #898989;
        font-size: 18px;
        text-align: left;
        cursor: pointer;
        .icon {
          width: 16px;
          height: 16px;
          margin-left: 18px;
          margin-right: 8px;
        }
        &.active {
          background: #f1f8fd;
          color: #67b0dc;
        }
      }
      .hr {
        width: 92px;
        height: 0;
        border-bottom: 1px dashed #898989;
        margin: 30px 0 30px 18px;
      }
    }
    .child {
      // position: absolute;
      margin-left: 50%;
      transform: translateX(-50%);
      // padding: 50px 0 30px 0;
      width: 140px;
      bottom: 75px;
      margin-top: 60px;
    }
  }
  #rightChat {
    flex: 1 1 0%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 20px;
    box-sizing: border-box;
    background: #f1f8fd;
    #headerChat {
      width: 100%;
      background: #fff;
      height: 70px;
      border-radius: 0 0 12px 12px;
      padding: 15px;
      box-sizing: border-box;
      display: flex;
      flex-direction: row;
      .headLeft {
        flex: 1 1 0%;
        display: flex;
        flex-direction: row;
        align-items: flex-end;
        justify-content: flex-start;
        .welcome {
          width: 118px;
          margin-right: 15px;
        }
        .school {
          font-size: 16px;
          color: #898989;
          margin-right: 8px;
        }
        .grade {
          font-size: 16px;
          color: #898989;
          margin-right: 8px;
        }
      }
      .headRight {
        flex: 1 1 0%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
        .msg {
          position: relative;
          padding-right: 26px;
          cursor: pointer;
          box-sizing: border-box;
          position: relative;
          &.border::after {
            position: absolute;
            content: "";
            top: 8px;
            bottom: 8px;
            right: 0;
            width: 1px;
            background: #dedede;
          }
          // margin-right: 80px;
          .red-msg {
            position: absolute;
            top: -4px;
            left: 30px;
            padding: 0 5px;
            height: 16px;
            color: #fff;
            background: #ff0000;
            font-size: 12px;
            line-height: 16px;
            text-align: center;
            border-radius: 16px;
          }
          img {
            width: 40px;
            height: 40px;
          }
        }
        .upload {
          position: relative;
          padding-right: 26px;
          box-sizing: border-box;
          cursor: pointer;
          img {
            width: 40px;
            height: 40px;
          }
        }
        .tx {
          cursor: pointer;
          width: 40px;
          height: 40px;
          margin-left: 20px;
          border-radius: 100%;
          margin-right: 12px;
        }
        .name {
          font-size: 16px;
          cursor: pointer;
          color: #898989;
        }
      }
    }
    #ctxChat {
      flex: 1 1 0%;
      width: 100%;
      position: relative;
      .wrapper {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
      }
    }
  }
}
::-webkit-scrollbar-track-piece {
  background-color: #f8f8f8;
}
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-thumb {
  background-color: #dddddd;
  background-clip: padding-box;
  min-height: 28px;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb:hover {
  background-color: #bbb;
}

.swap {
  background: #71b4dd;
  border-radius: 20px;
  padding: 1px 6px;
  font-size: 12px;
  color: #fff;
  cursor: pointer;
  span {
    margin-left: 2px;
  }
}


</style>
